import { BenefitActivityLogQueryType } from "../../../slices/partner-program/benefits-log/Types";

export const benefitsLogSagaActionTypes = {
  callGetBenefitsLogSaga: "callGetBenefitsLogSaga",
  callUpsertBenefitsLogSaga: "callUpsertBenefitsLogSaga",
  callDeleteBenefitsLogSaga: "callDeleteBenefitsLogSaga",
  callGetBenefitMediaViewUrlSaga: "callGetBenefitMediaViewUrlSaga",
};

export type GetBenefitsLogPayloadType = {
  partnerId: number;
  /** Omit to reuse the last query for this partner (e.g. refresh after save). */
  query?: BenefitActivityLogQueryType;
  onSuccess?: () => void;
  onError?: (message?: string) => void;
};

export const getBenefitsLogSagaAction: (data: GetBenefitsLogPayloadType) => {
  type: string;
  payload: GetBenefitsLogPayloadType;
} = (data: GetBenefitsLogPayloadType) => {
  return {
    type: benefitsLogSagaActionTypes.callGetBenefitsLogSaga,
    payload: data,
  };
};

export type UpsertBenefitsLogPayloadType = {
  id?: number;
  partner_id: number;
  benefit_id?: number | null;
  planned_date?: string | null;
  delivered_date?: string | null;
  HID_user_id: number[];
  partner_user_id: number[];
  status: string;
  comments?: string | null;
  created_by: number;
  files?: File[];
  deleted_media_ids?: number[];
  onSuccess?: (message?: string) => void;
  onError?: (message?: string) => void;
};

export const upsertBenefitsLogSagaAction: (
  data: UpsertBenefitsLogPayloadType
) => {
  type: string;
  payload: UpsertBenefitsLogPayloadType;
} = (data: UpsertBenefitsLogPayloadType) => {
  return {
    type: benefitsLogSagaActionTypes.callUpsertBenefitsLogSaga,
    payload: data,
  };
};

export type DeleteBenefitsLogPayloadType = {
  id: number;
  partnerId: number;
  onSuccess?: (message?: string) => void;
  onError?: (message?: string) => void;
};

export const deleteBenefitsLogSagaAction: (
  data: DeleteBenefitsLogPayloadType
) => {
  type: string;
  payload: DeleteBenefitsLogPayloadType;
} = (data: DeleteBenefitsLogPayloadType) => {
  return {
    type: benefitsLogSagaActionTypes.callDeleteBenefitsLogSaga,
    payload: data,
  };
};

export type GetBenefitMediaViewUrlPayloadType = {
  fileKey: string;
  onSuccess?: (url: string) => void;
  onError?: (message?: string) => void;
};

export const getBenefitMediaViewUrlSagaAction: (
  data: GetBenefitMediaViewUrlPayloadType
) => {
  type: string;
  payload: GetBenefitMediaViewUrlPayloadType;
} = (data: GetBenefitMediaViewUrlPayloadType) => {
  return {
    type: benefitsLogSagaActionTypes.callGetBenefitMediaViewUrlSaga,
    payload: data,
  };
};
